import React from "react";

export default function Modal({ children, onClose }) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full min-h-[200px] max-h-[90vh] relative flex flex-col">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 text-xl font-bold"
          aria-label="Cerrar"
        >
          ×
        </button>
        <div className="flex-1 overflow-auto">{children}</div>
      </div>
    </div>
  );
}
